/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import { timeout } from 'ember-concurrency';

import config from 'cio/config/environment';
import CollectionModel from 'cio/models/collection';
import ImportModel from 'cio/models/import';

interface BlankSlateArgs {
  collection: CollectionModel;
  import: ImportModel;
  modelType: 'collection' | 'import';
  state: string | boolean;
  header: string;
  message: string;
  onStateChange: () => unknown;
}

export default class BlankSlate extends Component<BlankSlateArgs> {
  get modelType() {
    return this.args.modelType ?? 'import';
  }

  pollForCollectionStatus = task({ drop: true }, async () => {
    while (this.args.collection.importing) {
      await timeout(config.APP.importStatePollingDuration);
      await this.args.collection.reload();
    }
    this.args.onStateChange();
  });

  pollForImportStatus = task({ drop: true }, async () => {
    let sameState = true;
    while (sameState) {
      await timeout(config.APP.importStatePollingDuration);
      let record = await this.args.import.reload();
      sameState = record.state === this.args.state;
    }
    this.args.onStateChange();
  });

  constructor(owner: unknown, args: BlankSlateArgs) {
    super(owner, args);

    (this.modelType === 'import' ? this.pollForImportStatus : this.pollForCollectionStatus).perform();
  }
}
